// NPM Modules
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
// Components
import EditDialog from './EditDialog';
// Material-UI
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
// Material-UI List Components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
// Material-UI Dialog Components
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
// Material-UI Icons
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';
/**
 *
 * @param {*} props
 */
function PanelItem(props) {
  return (
    <ListItem dense>
      <ListItemText
        primary={
          <React.Fragment>
            <Typography variant="body1">{props.label}</Typography>
            <Typography variant="body2">{props.value}</Typography>
          </React.Fragment>
        }
      />
    </ListItem>
  );
}
/**
 *
 * @param {*} param0
 */
function ArrayInfoPanel({
  array,
  onEdit,
  canEdit,
  canDelete,
  onDelete,
  isMobile
}) {
  const [open, setOpen] = React.useState(true);
  const [openEditDialog, setOpenEditDialog] = React.useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  return (
    <React.Fragment>
      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
      >
        <DialogTitle>Delete array forever?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Once an array is deleted it can never be undeleted. This is a
            permanent action. Are you sure you want to delete this array?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button onClick={onDelete}>Delete forever</Button>
        </DialogActions>
      </Dialog>
      <EditDialog
        array={array}
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        onEdit={onEdit}
        isMobile={isMobile}
      />
      <List>
        <ListItem>
          <ListItemText
            primary={array.array_name}
            secondary={array.array_key}
          />
          <ListItemSecondaryAction>
            {canEdit ? (
              <Tooltip title="Edit array info">
                <IconButton
                  aria-label="edit"
                  onClick={() => setOpenEditDialog(true)}
                >
                  <EditRoundedIcon />
                </IconButton>
              </Tooltip>
            ) : null}
            {canDelete ? (
              <Tooltip title="Delete array">
                <IconButton
                  aria-label="delete"
                  onClick={() => setOpenDeleteDialog(true)}
                >
                  <DeleteForeverRoundedIcon />
                </IconButton>
              </Tooltip>
            ) : null}
            <Tooltip title="Toggle array info">
              <IconButton
                edge="end"
                aria-label="toggle"
                onClick={() => setOpen(!open)}
              >
                {open ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Tooltip>
          </ListItemSecondaryAction>
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <PanelItem
            label="Deployment:"
            value={
              <Link
                component={RouterLink}
                to={`../deployment/${array.deployment_key}`}
              >
                {array.deployment_name}
              </Link>
            }
          />
          <PanelItem
            label="Bounding Box Size X:"
            value={array.bounding_box_size_x}
          />
          <PanelItem
            label="Bounding Box Size Y:"
            value={array.bounding_box_size_y}
          />
          <PanelItem label="Description:" value={array.description} />
          <PanelItem label="Region:" value={array.region} />
        </Collapse>
      </List>
    </React.Fragment>
  );
}

export default ArrayInfoPanel;
